// extracted by mini-css-extract-plugin
export var title = "BrandingSectionTitle-module--title--4-VTs";